import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
    performRequest,
    initCategories,
    initTranslations,
    initLanguage,
    initPast,
    initThemeCategories,
    findAndSetSelectedProjectTag,
    findAndSetCategory,
} from './actions.mjs';

import ProjectItem from './ProjectItem';
import ProjectFilters from './ProjectFilters';
import ProjectTitle from './ProjectTitle';
import ProjectLoadMoreButton from './ProjectLoadMoreButton';
import ProjectThemeFilters from './ProjectThemeFilters.jsx';

class ProjectList extends Component {
  constructor(props) {
    super(props);
    props.dispatch(initCategories(JSON.parse(props.categories)));
    props.dispatch(initTranslations(JSON.parse(props.translations)));
    props.dispatch(initLanguage(props.language));
    props.dispatch(initPast(JSON.parse(props.past)));
    props.dispatch(initThemeCategories(JSON.parse(props.themeCategories)));
    
    if (props.selectedCategory !== props.selectedUrlCategory) {
      props.dispatch(findAndSetCategory(props.selectedCategory))
      props.dispatch(findAndSetSelectedProjectTag(props.selectedCategory))
    }
  }
  
  componentDidMount() {
    if (!this.props.hits.length) {
      this.props.dispatch(performRequest({ past: this.props.past }));
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedUrlCategory !== this.props.selectedUrlCategory) {
      this.props.dispatch(performRequest({past: this.props.past, replace: true}))
    }
  }

  render() {
    return (
      <div className="container__react">
        <ProjectTitle title={this.props.title} />
        <ProjectFilters past={this.props.past} />
        <ProjectThemeFilters past={this.props.past } />
        <div className="container container--medium" id={this.props.sectionid}>
          {this.props.hits.map((hit, index) => {
            return <ProjectItem hit={hit} key={index} />;
          })}
        </div>
        <ProjectLoadMoreButton />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    hits: state.results.hits,
    category: state.category,
    themeCategory: state.themeCategory,
    selectedUrlCategory: state.selectedUrlCategory,
  };
}

export default connect(mapStateToProps)(ProjectList);
